export const DataTestimonial = [
  {
    id: 1,
    image: "assets/eya-dh.jpeg",
    title: "Eya Dhaouedi(Client)",
    description:
      "I wanted to take a moment to express my sincere appreciation for the exceptional work you’ve done. Your ability to create new user-friendly features is nothing short of remarkable, and your knack for clearly explaining options has been invaluable. It’s this combination of innovation and clarity that has enabled me to progress swiftly and efficiently.Thank you for being such a pivotal part of my success.",
  },
  {
    id: 2,
    image: "assets/sarah.jpeg",
    title: "Sarah Souguir(Client)",
    description:
      "I enjoyed working with you , You excel at creating new user friendly features ,  and clearly explaining options . This allows me to move forward quickly and efficiently",
  },

  {
    id: 3,
    image: "assets/rania.jpg",
    title: "Rania Jebli(Client)",
    description: `I want to thank you for the efforts u made to my fertinat
I appreciate your hard work and your commitment i wish you all the success in your career and thanks again ❤️`,
  },
  {
    id: 4,
    image: "assets/takwa-img.jpg",
    title: "Takwa Kraiem(Client)",
    description: `Hazem was very helpful during my project.
     He generously offered his time and support whenever I needed assistance.
      His explanations were clear, and he showed a solid understanding of the subject.
       I truly appreciated his willingness to help and his positive attitude.
        He made a real difference, and I’m thankful for his support.`,
  },
  {
    id: 5,
    image: "assets/talel.jpg",
    title: "Talel Ben belgacem(Instructor)",
    description:
      "Congratulations on the hard work dear student Hazem, I wish you all the best and success 💪 ",
  },
];
